// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".truncate-container[data-v-57897234]{overflow:hidden}.truncate-container .text-truncate[data-v-57897234],.truncate-container .v-list-item-subtitle[data-v-57897234],.truncate-container .v-list-item-title[data-v-57897234],.truncate-container>*[data-v-57897234]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", ""]);
// Exports
module.exports = exports;
